// extracted by mini-css-extract-plugin
module.exports = {"content":"StepPayment_content__WV4lc","wrapper":"StepPayment_wrapper__FXEIX"};